var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
var Scores = /** @class */ (function (_super) {
    __extends(Scores, _super);
    function Scores() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Scores.prototype.render = function () {
        var score = this.props.score;
        return _jsxs("span", { children: [score.get('score1'), ":", score.get('score2')] });
    };
    Scores.propTypes = {
        score: PropTypes.object
    };
    return Scores;
}(React.Component));
function mapStateToProps(state, props) {
    var id = props.id, section = props.section;
    var score = state.application.getIn([section, 'scores', id]);
    return {
        score: score
    };
}
Scores = connect(mapStateToProps)(Scores);
export default Scores;



// WEBPACK FOOTER //
// ./src/components/grid/live/Scores.jsx